export default [
  {
    name: 'LineBauerfeinSignup',
    path: '/line/bauerfeind/signup',
    component: () => import('@/pages/LineBauerfeind/Signup'),
    meta: {
      title: '保固註冊',
      isSupportMobile: true
    }
  },
  {
    path: '/line/bauerfeind/:id',
    name: 'LineBauerfeind',
    component: () => import('@/layouts/LineBauerfeind/index'),
    meta: {
      title: '我的保固',
      isSupportMobile: true
    },
    props: true,
    children: [
      {
        name: 'LineBauerfeinWarrantyList',
        path: 'warranty',
        component: () => import('@/pages/LineBauerfeind/WarrantyList'),
        meta: {
          title: '我的保固',
          isSupportMobile: true
        }
      },
      {
        name: 'LineBauerfeinAfterSalesService',
        path: 'warranty/after-sales',
        component: () => import('@/pages/LineBauerfeind/AfterSalesService'),
        meta: {
          title: '售後服務',
          isSupportMobile: true
        }
      },
      {
        name: 'LineBauerfeinWarrantyRegister',
        path: 'warranty/register',
        component: () => import('@/pages/LineBauerfeind/WarrantyRegister'),
        meta: {
          title: '保固註冊',
          isSupportMobile: true
        }
      },
      {
        name: 'LineBauerfeinAdminWarrantyList',
        path: 'admin/warranties',
        component: () => import('@/pages/LineBauerfeind/AdminWarrantyList'),
        meta: {
          title: '管理保固',
          isSupportMobile: true,
          requiresAdmin: true
        }
      },
      {
        name: 'LineBauerfeinAdminWarrantyDetail',
        path: 'admin/warranties/:warrantyId',
        component: () => import('@/pages/LineBauerfeind/AdminWarrantyDetail'),
        meta: {
          title: '保固詳情',
          isSupportMobile: true,
          requiresAdmin: true
        }
      }
    ]
  }
]
